import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../client/components/ui/select";
import useTranslation from "../../client/hooks/useTranslation";

export default function TopbarSideFilterWidget({
  value,
  onChange,
}: {
  value: "all" | "long" | "short";
  onChange: (v: "all" | "long" | "short") => void;
}) {
  const t = useTranslation();
  return (
    <Select value={value} onValueChange={(v) => onChange(v as "all" | "long" | "short")}>
      <SelectTrigger className="h-9 w-[120px] text-sm">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">{t.journal.sideAll}</SelectItem>
        <SelectItem value="long">{t.journal.sideLong}</SelectItem>
        <SelectItem value="short">{t.journal.sideShort}</SelectItem>
      </SelectContent>
    </Select>
  );
}
